export const ROUTES = {
  AGENT_PAGE: '/agent-page/:agentId',
  AGENTS: '/agents',
  API_DOCS: '/api-docs',
  API_TOKEN: '/api-token',
  CAMPAIGNS: '/campaigns',
  CHANGE_HISTORY: '/change-history',
  SIMULATIONS: '/simulations',
  DASHBOARD: '/dashboard',
  DEMO: '/demo/:agentAltKey',
  DIALER_ADMIN: '/dialer/:campaignId/admin',
  DIALER_CALL_LOGS: '/dialer/call-logs',
  DIALER_CALLER_IDS: '/dialer/callerids',
  DIALER_SETTINGS: '/dialer/:campaignId/settings',
  DIALER_STATUS: '/dialer/:campaignId/status',
  DIALER_TASKS: '/dialer/:campaignId/admin/:instanceId/tasks',
  DIALER: '/dialer',
  HISTORY_CALL: '/history/:callId',
  HISTORY: '/history',
  LEAD_SEARCH: '/lead_search',
  LISTS: '/lists',
  LOGIN: `/login`,
  ORGANIZATION_SETTINGS: '/organization-settings',
  QA_CALL: '/qa/:callId',
  QA: '/qa',
  REALTIME: '/realtime',
  REPORTS: '/reports',
  SCRIPTS: {
    LIST: '/scripts',
    ITEM: '/scripts/:id',
  },
  SIMULATION_SETTINGS: '/simulation-settings',
  TOOL_TYPES_ADMIN: '/tool-types-admin',
  TOOLS: '/tools',
  TWILIO_NUMBERS: '/twilio-numbers',
  VOICES: {
    LIST: '/voices',
    ITEM: '/voices/:id',
  },
} as const;